import navigation from "@/lang/pt_PT/navigation";
import generics from "@/lang/pt_PT/generics";
import questions from "@/lang/pt_PT/questions";
import a11y from "@/lang/pt_PT/a11y";
import velt from "@/lang/pt_PT/velt";

export default {
  ...navigation,
  ...generics,
  ...questions,
  ...a11y,
  ...velt
}
